import * as React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {injectIntl} from "react-intl";
import './index.scss'
import {PaymentTypeOptions} from "@models/paymentType";
import __i18n from "../../../intl/__i18n";

function NewUsersChart({data, intl}) {
  const {formatMessage} = intl;
  
  return (
    <div className={'chart-wrapper'}>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            type: 'column'
          },
          title: {
            text: ""
          },
          subtitle: {
            text: __i18n("Collective report of all payment types")
          },
          xAxis: {
            type: 'category',
          },
          
          yAxis: {
            min: 0,
            title: {
              text: formatMessage({
                id: "app.sum_amount",
                defaultMessage: "Total Amount"
              })
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: [{
            name: formatMessage({
              id: "app.sum_amount",
              defaultMessage: "Total Amount"
            }),
            data: data.map(item => [PaymentTypeOptions.find( opt => opt.value === item.payment_type)["label"], item.sum_amount]),
          }]
        }}
      />
    </div>
  )
}

export default injectIntl(NewUsersChart);

